/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
export type JobInvoiceStatus = "A_1" | "A_2" | "A_3" | "A_4" | "A_5" | "%future added value";
import type { FragmentReference } from "relay-runtime";
declare export opaque type InvoicesList_job$ref: FragmentReference;
declare export opaque type InvoicesList_job$fragmentType: InvoicesList_job$ref;
export type InvoicesList_job = {|
  +id: string,
  +currencyCode: ?string,
  +invoices: ?{|
    +edges: $ReadOnlyArray<?{|
      +node: ?{|
        +id: string,
        +identifier: string,
        +status: JobInvoiceStatus,
        +created: any,
        +amount: number,
        +verificationDate: ?any,
      |}
    |}>
  |},
  +$refType: InvoicesList_job$ref,
|};
export type InvoicesList_job$data = InvoicesList_job;
export type InvoicesList_job$key = {
  +$data?: InvoicesList_job$data,
  +$fragmentRefs: InvoicesList_job$ref,
};
*/


const node/*: ReaderFragment*/ = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Fragment",
  "name": "InvoicesList_job",
  "type": "JobNode",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    (v0/*: any*/),
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "currencyCode",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "invoices",
      "storageKey": "invoices(orderBy:\"-created\")",
      "args": [
        {
          "kind": "Literal",
          "name": "orderBy",
          "value": "-created"
        }
      ],
      "concreteType": "InvoiceNodeConnection",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "edges",
          "storageKey": null,
          "args": null,
          "concreteType": "InvoiceNodeEdge",
          "plural": true,
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "node",
              "storageKey": null,
              "args": null,
              "concreteType": "InvoiceNode",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "identifier",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "status",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "created",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "amount",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "verificationDate",
                  "args": null,
                  "storageKey": null
                }
              ]
            }
          ]
        }
      ]
    }
  ]
};
})();
// prettier-ignore
(node/*: any*/).hash = 'c60a990e01607a1c379cf0e5e0fefc1c';
module.exports = node;
